<template>
  <div>
    <MobileMainEvents
      v-if="$vuetify.breakpoint.width < 750"
      :mainEvents="mainEvents"
    />

    <DesktopMainEvents v-else :mainEvents="mainEvents" />
  </div>
</template>

<script>
import MobileMainEvents from "./MobileMainEvents.vue";
import DesktopMainEvents from "./DesktopMainEvents.vue";

export default {
  data: () => ({
    mainEvents: [],
  }),
  components: { MobileMainEvents, DesktopMainEvents },
  computed: {
    mainEventsStatus() {
      return this.$store.state.operators.main_events;
    }
  },
  created() {
    if (this.mainEventsStatus == "1") {
      this.fetchMainEvents();
    }
  },
  methods: {
    fetchMainEvents() {
      this.$axios
        .post(
          "player/table/mainEvents",
          this.$formdata({ domain: this.$domain() })
        )
        .then((res) => {
          const data = res.data.dados;
          const mainEvents = [];

          for (const index in data) {
            mainEvents.push(data[index]);
          }

          mainEvents.forEach((event) => {
            const [firstTeam, secondTeam] = event.description.split("X");
            event.firstTeam = firstTeam;
            event.secondTeam = secondTeam;

            for (let odd of event.odds) {
              odd = this.$treatOdd(odd);
            }
          });

          this.mainEvents = mainEvents;
          this.filterMainEvents();

          const _this = this;
          setTimeout(() => {
            setInterval(_this.filterMainEvents, 60000);
            _this.filterMainEvents();
          }, (60 - new Date().getSeconds()) * 1000);
        })
        .catch(() => {
          this.mainEvents = [];
        });
    },
    filterMainEvents() {
      const now = new Date();

      this.mainEvents = this.mainEvents.flatMap((event) => {
        const scheduled = new Date(event.scheduled);

        if (now < scheduled && this.isToday(scheduled)) {
          const minutes = this.getMinuteDifferenceBetweenDates({
            startDate: now,
            endDate: scheduled,
          });

          if (minutes > 0 && minutes <= 60) {
            return [{
              ...event,
              dayText: this.$t("today").toLowerCase(),
              startingSoon: this.$t("startingSoon", { minutes }),
            }];
          }

          return [{
            ...event,
            dayText: this.$t("today").toLowerCase(),
          }];
        }

        return [];
      });
    },
    getMinuteDifferenceBetweenDates({ startDate, endDate }) {
      const diff = endDate.getTime() - startDate.getTime();
      return Math.round(diff / 60000);
    },
    isToday(date) {
      const today = new Date();

      return (
        today.getFullYear() === date.getFullYear() &&
        today.getMonth() === date.getMonth() &&
        today.getDate() === date.getDate()
      );
    },
  },
};
</script>
